import React from 'react';
import {
  takeEvery,
  call,
  put,
} from 'redux-saga/effects';
import { isEmpty, forEach } from 'lodash';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import config from '../../config';
import * as types from '../types';

function* oakMemberLogin(action) {
  try {
    const data = yield call(
      axios.post,
      `${config.API}/oakmember/login`,
      action.payload,
    );
    yield put({
      type: types.REGISTER_OAK_MEMBER_LOGIN_SUCCESS,
      payload: {
        id: data.data.id,
        email: action.payload.email,
      },
    });
    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
  } catch (err) {
    console.error(err);
    yield call(toast, <FormattedMessage id="Sagas.Errors.OakmemberLogin" />);
    yield put({
      type: types.REGISTER_OAK_MEMBER_LOGIN_FAILURE,
    });
  }
}

function* registerCompetition(action) {
  try {
    const data = new FormData();
    data.append('id', action.payload.id);
    data.append('email', action.payload.email);
    data.append('name', action.payload.name);
    data.append('phone', action.payload.phone);
    data.append('affiliation', action.payload.affiliation);
    data.append('age', action.payload.age);
    data.append('notes', action.payload.notes);
    if (!isEmpty(action.payload.consent_form)) {
      data.append('consent_form', action.payload.consent_form);
    }
    if (!isEmpty(action.payload.design)) {
      data.append('design', action.payload.design);
    }
    // Loop and inject team member data.
    if (!isEmpty(action.payload.members)) {
      forEach(action.payload.members, (member, index) => {
        data.append(`${index}_name`, member.name);
        data.append(`${index}_age`, member.age);
        data.append(`${index}_consent_form`, member.consent_form);
      });
    }

    console.log('raw', action.payload);

    yield call(
      axios.post,
      `${config.API}/entry-form`,
      data,
    );
    yield put({
      type: types.REGISTER_COMPETITION_SUCCESS,
    });
    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
  } catch (err) {
    console.error(err);
    yield call(toast, <FormattedMessage id="Sagas.Errors.Registration" />);
    yield put({
      type: types.REGISTER_COMPETITION_FAILURE,
    });
  }
}

export default function* () {
  yield takeEvery(types.REGISTER_OAK_MEMBER_LOGIN_REQUEST, oakMemberLogin);
  yield takeEvery(types.REGISTER_COMPETITION_REQUEST, registerCompetition);
}
